export const MIN_CHUNK_WIDTH_PX = 100;
export const CHUNK_GAP_PX = 4;
export const ADD_CHUNK_WIDTH_PX = 110;
export const ADD_CHUNK_MARGIN_LEFT_PX = 5;
